import { useQuery } from "@tanstack/react-query";
import { Event } from "../models/Event";
import { getMillEvents } from "../repositories/calendarRepository";

export const useSearchEvents = ({
	start,
	end,
	onError,
}: {
	start: Date;
	end: Date;
	onError?: (error: Error) => void;
}) => {
	return useQuery<Event[], Error>({
		queryKey: ["millCalendarEvents", start.getTime(), end.getTime()],
		queryFn: ({ signal }) => getMillEvents({ start, end }, signal),
		refetchInterval: 60_000,
		onError,
	});
};
